import { IconSpriteTimes } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { configGetSite } from 'common/helper/config/get-site';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { PropertyCallTooltipTemplatePropsInterface } from 'desktop/module/property/call-tooltip/template-props.interface';

export const PropertyCallTooltipTemplate: FunctionalComponent<PropertyCallTooltipTemplatePropsInterface> = (props) => (
  <div>
    <div className='phone-tooltip__close' onClick={(e): void => props.onClickClose(e)}>
      <IconSpriteTimes className='phone-tooltip__close-icon' />
    </div>
    {props.model.meta.contact_options.details.phone.is_did && (
      <div className='phone-tooltip__heading'>{i18nTranslate('This number accepts calls only')}</div>
    )}
    <div className='phone-tooltip__label'>{i18nTranslate('Mention the reference')}</div>
    <div className='phone-tooltip__reference'>
      "{configGetSite().name} <span className='phone-tooltip__reference-number'>{props.model.reference}</span>"
    </div>
  </div>
);
